import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import "./firsttimelogin.scss";
import LogoNavbar from "../../../components/LogoNavbar/LogoNavbar";
import Cookies from "js-cookie";
import { useFetchInitialSiteData } from "../../../hooks/siteData/useInitialSiteData";
import { useDispatch } from "react-redux";
import {
  setPartnerRoles,
  setPartnerSkills,
  setUserLanguages,
} from "../../../store/Partner/siteData";
function FirstTimeLoginLayout() {
  const dispatch = useDispatch();

  const { isPending, error, data: initialSiteData } = useFetchInitialSiteData();
  console.log("Data:", initialSiteData, isPending, error);

  useEffect(() => {
    if (initialSiteData) {
      console.log("Initial Site Data:", initialSiteData);
      dispatch(setPartnerRoles(initialSiteData.partnerRoles));
      dispatch(setPartnerSkills(initialSiteData.partnerSkills));
      dispatch(setUserLanguages(initialSiteData.userLanguages));
    }
  }, [initialSiteData]);

  const newUser = Cookies.get("newUser");
  const navigate = useNavigate();
  console.log("NewUser:", newUser);

  // if (!newUser) {
  //   console.log("Existing:", newUser);
  //   return navigate("/dashboard", { replace: true });
  // }

  return (
    <div className="first-time-login">
      <LogoNavbar />

      <div className="main-body">
        <Outlet />
      </div>
    </div>
  );
}

export default FirstTimeLoginLayout;
